import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'
import * as userTypes from '../types/userTypes'

export const getSingleUser = (id) => {
  return async () => {
    const res = await privateAPI.post(`/general/get-single-user-data`, {
      data: { userId: id },
    })
    if (res) {
      let resp = decrypt(res.data)
      // dispatch({
      //   type: userTypes.GET_SINGLE_USER,
      //   payload: resp?.[0],
      // });
      return resp
    }
  }
}

export const getUserPurchases = (id) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/discount-full-user`, {
      data: {
        userId: id,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: userTypes.GET_USER_PURCHASE,
        payload: resp,
      })
      return resp
    }
  }
}

export const getUserSpendings = (id) => {
  return async (dispatch) => {
    const res = await privateAPI.post(
      `https://hanker.com.pk/api/getUserSpendingGraphDataByUserId.php?userId=${id}`,
    )
    if (res) {
      dispatch({
        type: userTypes.GET_USER_SPENDINGS,
        payload: res.data.Result,
      })
      return res.data.Result
    }
  }
}

// export const getSingleUserData = (id) => {
//   return async (dispatch) => {
//     const vendorId = localStorage.getItem("vendorId");

//     const res = await privateAPI.get(`${url}/get-single-user/${id}/${vendorId}`);
//     if (res) {

//       // dispatch({
//       //   type: userTypes.GET_SINGLE_USER,
//       //   payload: res.data[0],
//       // });
//       // return res.data;
//     }
//   };
// };

export const getOfflineCustomer = (number) => {
  return async (dispatch) => {
    let data = {
      number,
    }
    const res = await privateAPI.post(`/general/get-offline-customer`, {
      data: data,
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch({
        type: userTypes.GET_SINGLE_USER,
        payload: resp.orders,
      })
    }
  }
}
